const Tables = {
    ApiCache: 'ufe_api_cache',
    Cache: 'ufe_cache',
    CsfAttribution: 'csf_attribution'
};

export default Tables;
